export enum AddBillEmailOption {
  SendToEmail = "sendToEmailOption",
  RedirectToEmail = "redirectToEmailOption",
}
